

import React from 'react';
import { Button, Card, CardBody, Container, Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


function ErrorMessage({ titleKey, messageKey, buttonLabelKey, buttonTo }) {
    const { t } = useTranslation();

    return (
        <Container fluid className="vh-100 d-flex align-items-center justify-content-center background-container">
            <Row className="w-100">
                <Col md="12" lg="6" className="mx-auto">
                    <Card>
                        <CardBody>
                            <h1 className="text-center">{t(titleKey)}</h1>
                            <h4 className="text-center mb-4">{t(messageKey)}</h4>
                            <div className="text-center">
                                <Button color="primary" tag={Link} to={buttonTo}>
                                    {t(buttonLabelKey)}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ErrorMessage;
